/**
 * Utility function to safely access localStorage.
 * @returns Returns the localStorage object if available, otherwise returns undefined.
 */
export const getSafeStorage = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return window.localStorage;
    }
  } catch (error) {
    console.warn('localStorage is not available:', error);
  }
  return undefined;
};
